import apiClient from './client'

export type NoteType = 'general' | 'injury' | 'achievement' | 'observation' | 'program'

export interface AthleteNote {
  id: string
  athlete_id: string
  organization_id: string
  assistant_id?: string
  title: string
  content: string
  note_type: NoteType
  created_by?: string
  created_at: string
  updated_at: string
}

export interface CreateAthleteNoteRequest {
  assistant_id: string
  title: string
  content: string
  note_type: NoteType
}

export interface UpdateAthleteNoteRequest {
  title: string
  content: string
  note_type: NoteType
}

export interface AthleteNotesResponse {
  notes: AthleteNote[]
  total: number
  limit: number
  offset: number
}

export const NOTE_TYPE_CONFIG: Record<NoteType, { icon: string; label: string; color: string }> = {
  general: { icon: '📝', label: 'Общее', color: '#F57C00' },
  injury: { icon: '🏥', label: 'Травма', color: '#E65100' },
  achievement: { icon: '🏆', label: 'Достижение', color: '#FFB74D' },
  observation: { icon: '👁', label: 'Наблюдение', color: '#FB8C00' },
  program: { icon: '📋', label: 'Программа', color: '#FF9800' },
}

export const athleteNotesApi = {
  getByAthleteId: async (athleteId: string, params?: { limit?: number; offset?: number; type?: NoteType }): Promise<AthleteNotesResponse> => {
    const { data } = await apiClient.get(`/athletes/${athleteId}/notes`, { params })
    return data
  },

  create: async (athleteId: string, req: CreateAthleteNoteRequest): Promise<AthleteNote> => {
    const { data } = await apiClient.post(`/athletes/${athleteId}/notes`, req)
    return data
  },

  update: async (athleteId: string, noteId: string, req: UpdateAthleteNoteRequest): Promise<AthleteNote> => {
    const { data } = await apiClient.put(`/athletes/${athleteId}/notes/${noteId}`, req)
    return data
  },

  delete: async (athleteId: string, noteId: string): Promise<void> => {
    await apiClient.delete(`/athletes/${athleteId}/notes/${noteId}`)
  },
}
